import {
  ADDRESS_REGEX,
  POSTAL_CODE_REGEX,
  validEmptyText,
  validSearchInput,
} from '@/utils/validators';
import { PROVINCES } from './provinces';

export const SHIPPING_ADDRESS = {
  ID: 'shipping-address',
  TITLE: 'Dirección de envío SIM',
  KEEP_ADDRESS_CHECK: {
    NAME: 'keep-address-check',
    ID: 'keep-address-check',
    RULES: {
      REQUIRED: 'Debes aceptar las condiciones',
      VALIDATE: {
        REQUIRED: {
          checkFunc: validSearchInput,
          message: 'Campo obligatorio',
        },
      },
    },
  },
  HORIZONTAL_ADDRESS: {
    ID: 'horizontal-shipping-address',
    NAME: 'shipping street-address',
    LABEL: 'Calle, número, localidad, código postal',
    RULES: {
      REQUIRED: 'Campo obligatorio',
      VALIDATE: {
        REQUIRED: {
          checkFunc: validSearchInput,
          message: 'Campo obligatorio',
        },
      },
    },
  },
  VERTICAL_ADDRESS: {
    ID: 'vertical-shipping-address',
    NAME: 'shipping address-level2',
    LABEL: 'Escalera, planta, puerta',
    RULES: {
      REQUIRED: 'Campo obligatorio',
      VALIDATE: {
        REQUIRED: {
          checkFunc: validSearchInput,
          message: 'Campo obligatorio',
        },
      },
    },
  },
  MANUAL_ADDRESS_CHECKBOX: {
    ID: 'manual-address-checkbox',
    NAME: 'manual-address-checkbox',
    LABEL: 'No encuentro mi dirección',
  },
  ADDRESS: {
    ID: 'shipping-address',
    NAME: 'shipping street-address',
    LABEL: 'Calle, número, localidad',
    RULES: {
      REQUIRED: 'Campo obligatorio',
      PATTERN: {
        ADDRESS_FORMAT: {
          value: ADDRESS_REGEX,
          message: 'Campo no válido',
        },
      },
      VALIDATE: {
        EMPTY_TEXT: {
          checkFunc: validEmptyText,
          message: 'Campo obligatorio',
        },
      },
    },
  },
  POSTAL_CODE: {
    ID: 'shipping-postal-code',
    NAME: 'shipping postal-code',
    LABEL: 'Código postal',
    RULES: {
      REQUIRED: 'Campo obligatorio',
      PATTERN: {
        ADDRESS_FORMAT: {
          value: POSTAL_CODE_REGEX,
          message: 'Campo no válido',
        },
      },
    },
  },
  ADDRESS_DETAIL: {
    ID: 'shipping-address-detail',
    NAME: 'shipping address-level2',
    LABEL: 'Escalera, planta, puerta',
    RULES: {
      REQUIRED: 'Campo obligatorio',
      PATTERN: {
        ADDRESS_FORMAT: {
          value: ADDRESS_REGEX,
          message: 'Campo no válido',
        },
      },
    },
  },
  STREET_NUMBER: {
    ID: 'street-number',
    NAME: 'street-number',
    LABEL: 'Número',
    RULES: {
      REQUIRED: 'Campo obligatorio',
      PATTERN: {
        ADDRESS_FORMAT: {
          value: ADDRESS_REGEX,
          message: 'Campo no válido',
        },
      },
    },
  },
  FLOOR: {
    ID: 'floor',
    NAME: 'floor',
    LABEL: 'Planta',
    RULES: {
      REQUIRED: 'Campo obligatorio',
      PATTERN: {
        ADDRESS_FORMAT: {
          value: ADDRESS_REGEX,
          message: 'Campo no válido',
        },
      },
    },
  },
  DOOR: {
    ID: 'door',
    NAME: 'door',
    LABEL: 'Puerta',
    RULES: {
      REQUIRED: 'Campo obligatorio',
      PATTERN: {
        ADDRESS_FORMAT: {
          value: ADDRESS_REGEX,
          message: 'Campo no válido',
        },
      },
    },
  },
  PROVINCE: {
    ID: 'shipping-address-province',
    NAME: 'province',
    LABEL: 'Provincia',
    RULES: {
      REQUIRED: 'Campo obligatorio',
    },
    OPTIONS: PROVINCES,
    DEFAULT_VALUE: { label: 'Elige tu opción' },
  },
};
